import React from 'react';
import './App.css';

import { ApplicationWrapper, AuthType } from '@innovyze/stylovyze';
import { miniPageRoutes } from '@Pages';
import { globalization } from './i18n/globalization';

function App() {
	const pages = miniPageRoutes;

	return <ApplicationWrapper pages={pages} globalization={globalization} />;
}

export default App;
